import React from "react";
import { Helmet } from "react-helmet";
import DashboardLayout from "../components/DashboardLayout";
import PageCallToAction from "../components/PageCallToAction";
import HomeHero from "../components/home/HomeHero";
import GettingStarted from "../components/home/GettingStarted";
import HomeFeatures from "../components/home/HomeFeatures";
import CompanyLogos from "../components/home/CompanyLogos";

const Index = () => {
  return (
    <DashboardLayout>
      <Helmet>
        <title>OpenPipe | RL for Agents</title>
        <meta
          name="description"
          content="OpenPipe helps enterprises build and deploy customized AI models for production applications with advanced fine-tuning and reinforcement learning."
        />
      </Helmet>
      <div className="max-w-7xl mx-auto space-y-16 px-2 sm:px-4 md:px-8">
        <HomeHero />
        <CompanyLogos />
        <GettingStarted />
        <HomeFeatures />
        <PageCallToAction />
      </div>
    </DashboardLayout>
  );
};

export default Index;
